import { useEffect, useRef, useState } from "react";

export const useMapViewerState = () => {
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const mapWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsMapLoaded(true);
    }, 1500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return {
    isMapLoaded,
    mapWrapperRef,
  };
};
